import { render, staticRenderFns } from "./LoginSocatotsPage.vue?vue&type=template&id=ba46a3ae&"
import script from "./LoginSocatotsPage.vue?vue&type=script&lang=js&"
export * from "./LoginSocatotsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports